
(() => {
  const selector = [
    // Orichi Instagram feed
    '.user-profile-follow-button svg',
    '.orichi-instagram-item__icon svg',
    '.orichi-instagram-item__icon2 svg',
    '.orichi-instagram-overlay svg',

    // EComposer notification icons
    '#ecom-toast-icon > svg'
  ].join(', ');

  function fixAccessibilityIcons() {
    document.querySelectorAll(selector).forEach(svg => {
      if (svg.getAttribute('aria-hidden') !== 'true') {
        svg.setAttribute('aria-hidden', 'true');
      }

      if (svg.getAttribute('focusable') !== 'false') {
        svg.setAttribute('focusable', 'false');
      }
    });

const accessEaseDialog = document.querySelector('#accessease-widget');

if (accessEaseDialog) {
  accessEaseDialog.setAttribute(
    'aria-label',
    'Accessibility Widget'
  );

  if (accessEaseDialog.hasAttribute('aria-labelledby')) {
    accessEaseDialog.removeAttribute('aria-labelledby');
  }
}

  }

  function initialize() {
    fixAccessibilityIcons();

    const observer = new MutationObserver(fixAccessibilityIcons);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
